if(document.querySelector('.header')) {
    const $header = document.querySelector('.header');
    window.onload = isSticky($header);
}

function isSticky(element) {
    if(document.documentElement.clientWidth >= 768 ) {
        window.addEventListener('scroll', function() {
            if(pageYOffset >= 15) {
                element.classList.add('is__sticky')
                if(document.querySelector('#wpadminbar')) {
                    element.style.top = document.querySelector('#wpadminbar').clientHeight + 'px'
                }
            } else {
                element.classList.remove('is__sticky')
            }
        })
    }
}
